// 素材包列表
export function getMaterialPackageList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adMaterial/pageList',
    data
  })
}

// 新增，更新
export function saveMaterialPackage(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adMaterial/save',
    data
  })
}

// 素材包详情
export function getMaterialPackageDetail(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adMaterial/dataOne',
    data
  })
}

// 删除素材包
export function delMaterialPackage(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adMaterial/remove',
    data
  })
}

// 获取素材包广告位接口
export function getMaterialSpaceList(data) {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/base/getMaterialSpace',
    data
  })
}
